const version = {
  gitRepository: {
    latestTag: process.env.NEXT_PUBLIC_GIT_HEAD_LATEST_TAG,
    commit: process.env.NEXT_PUBLIC_GIT_HEAD_COMMIT,
    numberOfCommitsSinceLatestTag:
      process.env.NEXT_PUBLIC_GIT_HEAD_NUMBER_OF_COMMITS_SINCE_LATEST_TAG,
  },
};

export default version;
